import { Task } from '../../domain/task';
import { mapper } from '../../tools/mapping/mapper';
import { TaskEntity } from '../entity';
import type { AppDB } from '../db';

export class TaskRepository {
    constructor(private readonly database: AppDB) {}


    async clearTaskyId(ids: number[]) {
        await this.database.tasks.where('Id').anyOf(ids).toArray(async te => {
            for (let i = 0; i < te.length; i++) {
                if (te && te[i].Id !== undefined) {
                    await this.database.tasks.where('Id').equals(te[i].Id!).delete();
                }
            }
        })
    }

    async attachTask(task: Task, operatorId: number) {
        let taskId: number;
        const te = mapper.map(task, Task, TaskEntity);

        taskId = await this.database.tasks.add(te);
        const pe = await this.database.getOperatorEntityById(operatorId);
        await this.database.operators.update(operatorId, {
            TaskIds: pe?.TaskIds ? [...pe.TaskIds, taskId] : [taskId]
        });

        return taskId;
    }
}
